import { Col, Row } from "antd";
import React, { useEffect, useRef } from "react";
import { MatApoyo } from "../Generals";
//import { RenderDocument } from "../Material";
import { useSelector } from "react-redux";
import { nombreOPL, getObjetoAutoridad, getEmisionConvocatoria, getPartidosLocales } from "../../../Generals/autoridadesElectorales";


export default function Lesson3({ data, setLoading, objEntidad, origen }) {
  const isMounted = useRef(true);
  //Se obtiene el Entidad seleccionada del store de redux
  const { idEntidad, entidad } = useSelector((state) => state.entidad);

  if(idEntidad!==undefined){
    localStorage.setItem('idEntidad', idEntidad);
  }

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  //función que ontiene los datos de la entidad dependiendo si se visualiza la lección dsde el curso o desde materiales de capacitación
  const getDataEntidad = () =>{
    const dataEntidad = origen === 1 ?objEntidad : {idEntidad: idEntidad, entidad: entidad};
    return dataEntidad
  }

  const textSinPartido = () =>{
    // Obtenemos el idEntidad dependiendiendo si estamos viendo la lección desde la sección de materiales de capacitación o desde el curso
    const idEntidadOrigen = origen === 1 ? parseInt(objEntidad.idEntidad) : idEntidad; 
    // Creamos un array con las entidades a las que aplica el texto
    const entidadesSinPartido = [9]
    return entidadesSinPartido.includes(idEntidadOrigen) ? ' o sin partido' : ''
  }

  
  return (
    <div className="texto_parrafo">
      <p>
        Además de las autoridades electorales que revisamos en la lección anterior, otros actores que 
        participan en el proceso electoral son los partidos políticos y las candidaturas independientes{textSinPartido()}.
      </p>
      <p> 
      Los <b>partidos políticos</b> son entidades de interés público con personalidad jurídica y patrimonio 
      propios, con registro legal ante el Instituto Nacional Electoral, en el caso de los partidos nacionales, 
      o ante {nombreOPL(parseInt(getDataEntidad().idEntidad))}, en el caso de los partidos políticos locales. 
      Tienen derecho a participar en las elecciones para cargos a nivel federal, estatal y municipal; 
      gozan de derechos y prerrogativas, y además están sujetos a las obligaciones que establece la ley.
      </p>
      <p>
      Los partidos políticos tienen fines específicos; revisa el material de apoyo para que los conozcas. 
      </p>
      {data && data.indexOf(0) && <MatApoyo array={[data[0]]} />}
      <p>{/*Aqui falta saber cuantos partidos locales existen*/}
      {getPartidosLocales(parseInt(getDataEntidad().idEntidad))} Los partidos políticos tienen derechos y obligaciones; revisa el 
      siguiente material para conocerlos. 
      </p>
      {data && data.indexOf(1) && <MatApoyo array={[data[1]]} />}
      <p>
      Además de las obligaciones que revisamos, los partidos políticos tienen otras en materia de transparencia, 
      violencia política contra las mujeres en razón de género y equidad, las cuales puedes conocer en el siguiente enlace:
      </p>
      {data && data.indexOf(2) && <MatApoyo array={[data[2]]} />}
      <p>Los partidos políticos pueden participar en el proceso electoral postulando candidaturas de forma individual o a través 
        de coaliciones. {getObjetoAutoridad(parseInt(getDataEntidad().idEntidad)).participacionT1} Revisa el siguiente material para conocer las 
        características de las coaliciones.
      </p>
      {data && data.indexOf(3) && <MatApoyo array={[data[3]]} />}
      <p>
      ¿Sabes qué es una precampaña?
      </p>
      <p>
      Una <b>precampaña</b> es el conjunto de actos que durante los procesos internos de selección realizan los partidos políticos, 
      sus militantes, así como las y los precandidatos para definir a las y los candidatos conforme a los estatutos de cada partido. 
      </p>
      <p>
      Las y los precandidatos pueden:
      </p>
      <div className="listGuion"><span>Realizar actividades para obtener el respaldo a su candidatura</span></div >
      <div className="listGuion"><span>Tener acceso a los spots en radio y televisión que correspondan a los partidos </span></div >
      <div className="listGuion"><span>Rendir informes sobre sus ingresos y gastos</span></div >
      <div className="listGuion"><span>Difundir propaganda de precampaña</span></div >
      <div className="listGuion"><span>Respetar el periodo establecido para precampañas</span></div >
      <div className="listGuion"><span>Otorgar artículos promocionales de materiales textiles</span></div >
      <br/>
      <p>
      Las y los precandidatos no pueden: 
      </p>
      <div className="listGuion"><span>Realizar actos anticipados de campaña</span></div >
      <div className="listGuion"><span>Contratar o adquirir propaganda en radio y televisión</span></div >
      <div className="listGuion"><span>Participar simultanéame en dos o más procesos internos</span></div >
      <div className="listGuion"><span>Gastar más del tope de gastos de precampaña establecido</span></div >
      <p>
      <p>
      Para reforzar tu conocimiento sobre lo qué pueden y qué no pueden hacer las y los precandidatos ingresa 
      al siguiente enlace:
      </p>
      </p>
      {data && data.indexOf(4) && <MatApoyo array={[data[4]]} />}
      <p>
      Posterior a la precampaña, se <b>registran candidaturas</b> de partidos políticos a los cargos de elección 
      popular. {getObjetoAutoridad(parseInt(getDataEntidad().idEntidad)).participacionT2} postulante deberá presentar y obtener el registro de la 
      plataforma electoral en la que sus candidatos y candidatas participarán a lo largo de las campañas políticas, 
      para lo cual deberán acreditar que realizaron los procesos internos establecidos.
      </p>
      <p>
      Una vez registradas las candidaturas se llevan a cabo las <b>campañas electorales</b>, que son un conjunto de actividades que realizan 
      los partidos políticos, las coaliciones{getObjetoAutoridad(parseInt(getDataEntidad().idEntidad)).participacionT3} y las y los candidatos registrados para obtener el voto de la 
      ciudadanía. Se consideran actos de campaña todas las reuniones públicas, asambleas, marchas y, en general, aquellos actos en 
      que las y los candidatos o voceros de los partidos políticos se dirigen al electorado para promover sus candidaturas.
      </p>
      <p>
      El día de la Jornada Electoral y durante los tres días anteriores <b>NO se permite</b> realizar actos públicos de campaña, 
      de propaganda ni de proselitismo. 
      </p>
      <p>
      Revisa las <b>fechas clave</b> de tu Guía para que identifiques los periodos de precampaña y el registro de candidaturas y campañas 
      electorales de las elecciones que se llevarán a cabo en la entidad donde te desempeñaras como observador u observadora electoral. 
      </p>
      <p>
      Como vimos anteriormente, uno de los derechos de los partidos políticos es recibir financiamiento, el cual se divide en público y privado. 
      Puedes revisar las características de cada tipo de financiamiento en el siguiente material de apoyo.
      </p>
      {data && data.indexOf(5) && <MatApoyo array={[data[5]]} />}
      <p>
      Para repasar las características de los partidos políticos te invitamos a que veas el siguiente video:
      </p>
      {data && data.indexOf(6) && <MatApoyo array={[data[6]]} />}
      <p>
      Ahora estudiaremos las características de las <b>candidaturas independientes{parseInt(getDataEntidad().idEntidad) === 9 ? ' o sin partido' : ''}:</b>
      </p>
      <p>
      La <b>candidatura independiente{parseInt(getDataEntidad().idEntidad) === 9 ? ' o sin partido' : ''}</b> se refiere a la o el ciudadano mexicano que obtiene por parte de la autoridad electoral su registro para una 
      candidatura a un cargo de elección popular, sin necesidad de que un partido político la o lo postule. 
      </p>
      <p>
      Los procesos de selección de candidaturas independientes{parseInt(getDataEntidad().idEntidad) === 9 ? ' o sin partido' : ''} comprenden las siguientes etapas: 
      </p>
      <Row>
        <Col span={1}/>
        <Col span={1}>
          1.
        </Col>
        <Col span={20}>
          La <b>emisión de la Convocatoria</b>. El Consejo General del INE emitirá 
          la convocatoria dirigida a la ciudadanía interesada en postularse como candidatas o candidatos independientes a la 
          Presidencia de la República, Senadurías y Diputaciones Federales y el {getEmisionConvocatoria(parseInt(getDataEntidad().idEntidad))}
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
          2.
        </Col>
        <Col span={20}>
          Los actos <b>previos al registro</b>, es decir, la manifestación de la intención de participar 
          como candidato o candidata independiente.
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
          3.
        </Col>
        <Col span={20}>
          La <b>obtención de apoyo de la ciudadanía </b>se hará a partir del día siguiente a la fecha en que obtengan la 
          calidad de aspirantes a una candidatura independiente. Este apoyo es el respaldo de la ciudadanía inscrita en la Lista Nominal hacia una persona que busca 
          obtener una candidatura independiente. Podrán realizar actos para recabar el porcentaje de apoyo de la ciudadanía requerido, por ejemplo, a través de 
          reuniones públicas, asambleas o marchas.
        </Col>
      </Row>
      <Row>
        <Col span={1}/>
        <Col span={1}>
          4.
        </Col>
        <Col span={20}>
          En el <b>registro de candidaturas</b>, las y los ciudadanos que aspiren a participar como candidatas o candidatos 
          independientes deberán presentar su solicitud de registro y documentación requerida ante la autoridad electoral correspondiente.
        </Col>
      </Row>
      <br/>
      <p>
      Revisa el siguiente material de apoyo para conocer los derechos y obligaciones de las candidaturas independientes, también revisa las <b>fechas clave</b> de tu Guía para conocer los 
      periodos y características del registro.
      </p>
      {data && data.indexOf(7) && <MatApoyo array={[data[7]]} />}
      <p>
        Es importante que sepas que tanto los partidos políticos como las candidaturas independientes{textSinPartido()} tienen <b>derecho de acceso a la radio y 
        la televisión</b>.
      </p>
      <p>
      El <b>INE</b> es la única autoridad encargada de la administración del tiempo que corresponde al Estado en radio y televisión, para 
      garantizar el ejercicio de las prerrogativas y derechos en esta materia que la Constitución y la ley otorgan a los partidos 
      políticos y candidaturas independientes. También se encarga de la administración del tiempo que corresponde al Estado destinado 
      a los fines propios del Instituto y a los de otras autoridades electorales. 
      </p>
      <p>
      Para terminar, los partidos políticos, sus coaliciones, las candidaturas, incluyendo a las y los candidatos independientes{textSinPartido()}, 
      tienen la obligación de informar sobre el origen, monto, destino y aplicación de los recursos que reciben, para lo cual la <b>fiscalización</b> a 
      estas figuras está a cargo del Consejo General del INE por conducto de su Comisión de Fiscalización, que a su 
      vez es apoyada por la Unidad Técnica de Fiscalización, instancia que ejerce las facultades de supervisión, seguimiento y control 
      técnico. 
      </p>
      <p>
      Los detalles de los partidos políticos y las candidaturas independientes{textSinPartido()} los puedes consultar en el <b className="textoResaltado2">CAPÍTULO 3 </b> 
      de tu <b className="textoResaltado2">{data && data.indexOf(9) && <MatApoyo array={[data[9]]} tipo={1}/>},</b> que se encuentra disponible en el material de consulta de este curso.
      </p>
      <p>
      Antes de realizar la evaluación consulta el siguiente material de apoyo para reforzar lo que aprendiste. 
      </p>
      {data && data.indexOf(8) && <MatApoyo array={[data[8]]}/>}
      <p>
      ¡Felicidades, has concluido esta lección! Enseguida, realiza la actividad de autoevaluación para avanzar a la siguiente unidad.
      </p>
    </div>
  );
}
